<template>
    <div>

        <b-modal @show="onModalSearch" size="lg" :busy="saving" id="modal-helmet" title="Assign User Vehicle" hide-footer :disabled="saving" v-if="!loading">
            <b-form @submit.prevent.stop="onModalSearch">
                <div class="bg-light rounded d-block search">
                    <b-form @submit.prevent.stop="onModalSearch" @reset="onModalSearchReset" inline>
                        <b-input class="mb-2 mr-sm-2 mb-sm-0 form-control-range" placeholder="Plate"
                                 v-model="searchModal.plate"></b-input>
                        <b-input class="mb-2 mr-sm-2 mb-sm-0 form-control-range" placeholder="VIN"
                                 v-model="searchModal.vin"></b-input>
                        <div class="ml-auto">
                            <b-button type="reset" class="mb-2 mr-sm-2 mb-sm-0">Reset</b-button>
                            <b-button type="submit" variant="primary" class="mb-2 mb-sm-0" :disabled="loading">Search</b-button>
                        </div>
                    </b-form>
                </div>
            </b-form>

            <loader v-if="modalLoading"></loader>
            <div id="list" v-else>
                <div v-if="modalData.data.length > 0">
                    <b-table small striped hover :items="modalData.data" :fields="modalfields">
                        <template v-slot:cell(model)="data">
                            {{data.item.model.manufacturer.name}} {{data.value.name}}
                        </template>

                        <template v-slot:cell(users)="data">
                            <div v-if="data.value.length > 0">
                                <router-link class="badge badge-pill badge-primary mr-1" v-for="user in data.value" :key="user.id" :to="{ name: 'userDetail', params: { id: user.id }}">{{user.name}} {{user.surname}}</router-link>
                            </div>
                            <span v-else class="badge badge-light">None</span>
                        </template>

                        <template v-slot:cell(action)="row">
                            <div v-if="!isAsigned(row.item.users)">
                                <b-button size="sm" variant="info" v-b-modal="String(row.item.id)">Assign</b-button>
                                <b-modal :id="String(row.item.id)" title="Assign User Vehicle" @ok="() => assignVehicle(row.item.id)">
                                    <p class="my-4">Confirmation</p>
                                </b-modal>
                            </div>
                            <span v-else class="badge badge-dark">Assigned</span>
                        </template>

                        <template v-slot:cell(createdAt)="data">
                            {{ data.value | moment("MMMM Do YYYY") }}
                        </template>
                    </b-table>
                    <div class="ml-auto">
                        <b-pagination
                                @change="setPage"
                                :disabled="modalLoading"
                                align="right"
                                v-model="modalData.page"
                                :total-rows="modalData.total"
                                :per-page="searchModal.perPage"
                        ></b-pagination>
                    </div>
                </div>

                <div class="card text-center" v-else>
                    <div class="card-body">
                        <h5 class="card-title">Search Result</h5>
                        <p class="card-text">No Data</p>
                        <b-button @click="onSearchReset" variant="primary">Reset</b-button>
                    </div>
                    <div class="card-footer text-muted">
                        {{JSON.stringify(searchModal)}}
                    </div>
                </div>
            </div>
        </b-modal>

        <div class="bg-light d-block search">
            <b-form inline>
                <b-button v-b-modal.modal-helmet type="button" variant="primary" class="mb-2 mb-sm-0 ml-auto"
                          :disabled="loading">Add New
                </b-button>
            </b-form>
        </div>

        <loader v-if="loading"></loader>
        <div v-else>
            <div v-if="data.data.length > 0">
                <b-table class="mb-0" small striped hover :items="data.data" :fields="fields">
                    <template v-slot:cell(model)="data">
                        {{data.item.model.manufacturer.name}} {{data.value.name}}
                    </template>

                    <template v-slot:cell(users)="data">
                        <div v-if="data.value.length > 0">
                            <router-link class="badge badge-pill badge-primary mr-1" v-for="user in data.value" :key="user.id" :to="{ name: 'userDetail', params: { id: user.id }}">{{user.name}} {{user.surname}}</router-link>
                        </div>
                        <span v-else class="badge badge-light">None</span>
                    </template>

                    <template v-slot:cell(createdAt)="data">
                        {{ data.value | moment("MMMM Do YYYY") }}
                    </template>

                    <template v-slot:cell(action)="row">
                        <b-button size="sm" variant="danger" v-b-modal="String(row.item.id)">Delete</b-button>
                        <b-modal :id="String(row.item.id)" title="Delete User Vehicle" @ok="() => deleteVehicle(row.item.id)">
                            <p class="my-4">Confirmation</p>
                        </b-modal>
                    </template>
                </b-table>
            </div>
            <div class="text-center m-3" v-else>
                <h5 class="card-title">Search Result</h5>
                <p class="card-text">No Data</p>
            </div>
        </div>
    </div>
</template>

<script>
  import ShowError from "../../../../helpers/showError";
  import ContentLoader from '../../../../components/ContentLoader';
  import GetVehicles from "../../../../store/actions/getVehicles";
  import DetachUserVehicle from "../../../../store/actions/detachUserVehicle";
  import AssignUserVehicle from "../../../../store/actions/assignUserVehicle";

  export default {
    name: 'UserVehicles',
    components: {
      loader: ContentLoader,
    },
    data() {
      return {
        loading: false,
        modalLoading: false,
        saving: false,
        data: {
          data:[]
        },
        modalData: {
          data:[]
        },
        search: {
          perPage: 10,
          page: 1,
          plate: undefined,
          vin: undefined,
          userId: this.$route.params.id
        },
        searchModal: {
          perPage: 10,
          page: 1,
          plate: undefined,
          vin: undefined,
        },
        fields: ['model', 'year', 'plate', 'vin', 'createdAt', 'action'],
        modalfields: ['model', 'plate', 'vin', 'users', 'action'],
      }
    },
    async created() {
      this.onSearch();
    },
    methods: {
      isAsigned(users) {
        return users.find(user => Number(this.$route.params.id) === Number(user.id))
      },
      async assignVehicle(id) {
        try {
          this.loading = true;
          await AssignUserVehicle(Number(this.$route.params.id), Number(id));
          this.onSearchReset();
        } catch (e) {
          ShowError(this, e);
        } finally {
          this.loading = false;
        }
      },
      async deleteVehicle(id) {
        try {
          this.loading = true;
          await DetachUserVehicle(Number(this.$route.params.id), Number(id));
          this.onSearchReset();
        } catch (e) {
          ShowError(this, e);
        } finally {
          this.loading = false;
        }
      },
      setPage(page){
        this.search.page = page;
        this.onSearch();
      },
      async onSearch() {
        try {
          this.loading = true;
          this.data = await GetVehicles(this.search);
        } catch (e) {
          ShowError(this, e);
        } finally {
          this.loading = false;
        }
      },
      async onModalSearch() {
        try {
          this.modalLoading = true;
          this.modalData = await GetVehicles(this.searchModal);
        } catch (e) {
          ShowError(this, e);
        } finally {
          this.modalLoading = false;
        }
      },
      onModalSearchReset() {
        this.searchModal = {
          perPage: 10,
          page: 0,
          plate: undefined,
          vin: undefined,
        };
        this.onModalSearch();
      },
      onSearchReset() {
        this.search = {
          perPage: 100,
          page: 0,
          plate: undefined,
          vin: undefined,
          userId: this.$route.params.id
        };
        this.onSearch();
      },
      async onSave() {
        try {
          this.saving = true;

          await this.load();
        } catch (e) {
          ShowError(this, e);
        } finally {
          this.saving = false;
        }
      }
    }
  }
</script>

<style scoped>
    .search {
        padding: 10px;
    }
</style>
